module.exports = __webpack_public_path__ + "static/media/sky.cee1e467.svg";